import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import SimpleApiExplorer from '../components/SimpleApiExplorer';
import './PageStyles.css';

const Compliance = () => {
  const [showTryApi, setShowTryApi] = useState(false);
  const complianceRecords = [
    { id: 1, type: 'AML Check', transactionId: 'TXN123456', status: 'Passed', checkedAt: '2024-01-15 10:30:00', checkedBy: 'System' },
    { id: 2, type: 'Sanctions Screening', transactionId: 'TXN123457', status: 'Passed', checkedAt: '2024-01-15 11:15:00', checkedBy: 'System' },
    { id: 3, type: 'PEP Check', transactionId: 'TXN123458', status: 'Flagged', checkedAt: '2024-01-14 14:20:00', checkedBy: 'System' },
    { id: 4, type: 'AML Check', transactionId: 'TXN123459', status: 'Passed', checkedAt: '2024-01-14 16:45:00', checkedBy: 'System' },
    { id: 5, type: 'Sanctions Screening', transactionId: 'TXN123460', status: 'Passed', checkedAt: '2024-01-13 09:10:00', checkedBy: 'System' },
  ];

  const sampleRequest = {
    transaction_id: "TXN123461",
    compliance_type: "aml_check",
    customer_id: "CUST001",
    amount: 1500.00,
    currency: "USD",
    additional_data: {
      source_country: "US",
      destination_country: "IN"
    }
  };

  const sampleResponse = {
    status: "success",
    code: "200",
    message: "Compliance check completed",
    data: {
      compliance_id: 6,
      transaction_id: "TXN123461",
      compliance_type: "aml_check",
      status: "passed",
      risk_score: 0.15,
      checked_at: "2024-01-15T10:30:00Z",
      details: {
        aml_status: "clear",
        sanctions_status: "clear",
        pep_status: "clear"
      }
    },
    request_id: "req_123456789"
  };

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="card">
          <div className="card-header card-header-master">
            <h2>Compliance Records</h2>
            <button type="button" className="btn btn-secondary" onClick={() => setShowTryApi(true)}>
              Try API
            </button>
          </div>
          
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Type</th>
                <th>Transaction ID</th>
                <th>Status</th>
                <th>Checked At</th>
                <th>Checked By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {complianceRecords.map((record) => (
                <tr key={record.id}>
                  <td>{record.id}</td>
                  <td><strong>{record.type}</strong></td>
                  <td><code>{record.transactionId}</code></td>
                  <td>
                    <span className={`status-badge ${record.status.toLowerCase()}`}>
                      {record.status}
                    </span>
                  </td>
                  <td>{record.checkedAt}</td>
                  <td>{record.checkedBy}</td>
                  <td>
                    <button className="btn btn-success btn-sm">View Details</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showTryApi && <div className="try-api-sidebar-overlay" onClick={() => setShowTryApi(false)} aria-hidden="true" />}
        {showTryApi && (
          <aside className="try-api-sidebar">
            <SimpleApiExplorer
              apiName="Compliance API"
              endpoint="/api/v1/compliance/check"
              method="POST"
              sampleRequest={sampleRequest}
              sampleResponse={sampleResponse}
              onClose={() => setShowTryApi(false)}
            />
          </aside>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Compliance;
